import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { goToLandingPage } from '../../../core/authentication/landing';
import { ConstantService } from '../../services/constant.service';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.view.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthCallbackComponent implements OnInit {
  message: string;
  constructor(
    private _router: Router,
    private _authService: AuthenticationService,
    private _constService: ConstantService
  ) {
  }

  ngOnInit(): void {
    // MSAL has already handled the redirect response in initializeMsal().
    if (this._authService.isAuthenticated) {
      goToLandingPage(this._router, this._constService);
    } else {
      this._router.navigate(['']);
    }
  }
}
